/**
 * @file Account Related Fragments.
 */
import gql from 'graphql-tag';

export const SelfieStationAccountDetails = gql`
  fragment SelfieStationAccountDetails on Account {
    id
    email_address
    username
    name
    phone_number
  }
`;
